import React from 'react';
import cn from 'classnames';
import type { NivelGovbr } from 'volto-ministerio-publico-federal/helpers/Servicos';

const ROTULOS: Record<NivelGovbr, string> = {
  bronze: 'Bronze',
  prata: 'Prata',
  ouro: 'Ouro',
};

export interface MPFSeloGovbrProps {
  nivel: NivelGovbr;
  className?: string;
}

export const MPFSeloGovbr: React.FC<MPFSeloGovbrProps> = ({
  nivel,
  className,
}) => {
  const rotulo = ROTULOS[nivel];
  if (!rotulo) return null;

  return (
    <span
      className={cn('mpf-selo-govbr', `mpf-selo-govbr--${nivel}`, className)}
    >
      <span aria-hidden="true">gov.br · {rotulo}</span>
      <span className="sr-only">
        Requer login com conta gov.br nível {rotulo.toLowerCase()}
      </span>
    </span>
  );
};

export default MPFSeloGovbr;
